import React from "react";

function Image({ src, alt = "Image Name", className = "", ...props }) {
  const finalSrc = src || "/assets/images/no_image.png";
  return (
    <img
      src={finalSrc}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "/assets/images/no_image.png";
      }}
      {...props}
    />
  );
}

export default Image;
